import './img-txt'
import $ from 'jquery';

$(document).ready(function () {
    let elementsCard = $('.img-txt__card:odd');
    if (window.matchMedia("(max-width: 639px)").matches) {
       elementsCard.addClass('--odd');
    } else {
        elementsCard.removeClass('--odd');
    }

    $(window).resize(function () {
        let elementsCard = $('.img-txt__card:odd');
        if(window.matchMedia('(max-width: 639px)').matches){
            elementsCard.addClass('--odd');
        } else {
            elementsCard.removeClass('--odd');
        }
    });

    // let item = $('.img-txt__card').length;
    // if (window.matchMedia("(min-width: 640px)").matches) {
    //     if(item % 2 == 0) {
    //         $('.img-txt__card-wrapper').removeClass('--even');
    //     } else {
    //         $('.img-txt__card-wrapper').addClass('--even');
    //     }
    // }
});